import { alertMessagesArgsConfig, redirectUrlArgsConfig } from '../../utils/event_constants';

export const docusignActionData = [
  {
    name: 'initiateDocusign',
    label: 'Initiate Docusign',
    args: [...redirectUrlArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'sendForEsign',
    label: 'Send for eSign',
    args: [
      {
        name: 'agreementTemplate',
        label: 'Agreement Template',
        type: 'dropdown',
        optionsType: 'agreementTemplateApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'fetchDocusignContractDetails',
    label: 'Fetch DocuSign Contract Details',
    args: [
      {
        name: 'getItemIdFrom',
        label: 'Get Envelope Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'fetchDocusignSigningStatus',
    label: 'Fetch Signers Signing Status',
    args: [
      {
        name: 'getItemIdFrom',
        label: 'Get Envelope Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
